/* unplugin-vue-components disabled */import script from "./OrderDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./OrderDetails.vue?vue&type=script&setup=true&lang=js"

import "./OrderDetails.vue?vue&type=style&index=0&id=2290ada7&lang=scss&scoped=true"

import exportComponent from "/Users/fubeibei/TRAE_workspace/cuiwei_xcxsc/cw/travel-manage/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2290ada7"]])

export default __exports__